import { SelectOption } from '@/types/form.type.ts';

export enum CarEngineType {
    Petrol = 'petrol',
    Diesel = 'diesel',
    Electric = 'electric',
    Hybrid = 'hybrid',
}

export function getCarEngineTypeLabel(type: CarEngineType): string {
    switch (type) {
        case CarEngineType.Petrol:
            return 'Бензин';
        case CarEngineType.Diesel:
            return 'Дизель';
        case CarEngineType.Electric:
            return 'Электро';
        case CarEngineType.Hybrid:
            return 'Гибрид';
    }
}

export function getCarEngineTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarEngineType).forEach((type: CarEngineType) => {
        options.push({
            label: getCarEngineTypeLabel(type),
            value: type,
        });
    });

    return options;
}
